import { useEffect, useState } from 'react'
import { GLItemDTO } from '../../../DTO/GLItemDTO'
import LogChatMsgCompactRow from './LogChatMsgCompactRow'
import LogChatMsgExpandPanel from './LogChatMsgExpandPanel'
import { cloneGlItem, LogChatMsgStatus } from './logChatMsgHelpers'

export default function LogChatMsg({
  item,
  saveStart,
  saveCB,
  onClickDetail,
  className = '',
  marked = false,
  defaultExpanded = false,
  expandAll,
}: {
  item: GLItemDTO
  saveStart?: () => void
  saveCB: () => void
  onClickDetail?: (id: number) => void
  className?: string
  marked?: boolean
  defaultExpanded?: boolean
  expandAll?: boolean
}) {
  const [glitem, setglitem] = useState(item)
  const [status, setStatus] = useState(LogChatMsgStatus.idle)
  const [expanded, setExpanded] = useState(defaultExpanded)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    setglitem(item)
  }, [item])

  useEffect(() => {
    if (expandAll !== undefined) {
      setExpanded(expandAll)
    }
  }, [expandAll])

  function refreshLocal() {
    setglitem(cloneGlItem(glitem))
    setTick(t => t + 1)
  }

  async function saveContent(val: string) {
    if (saveStart) {
      saveStart()
    }
    glitem.content = val
    await glitem.save(true)
    saveCB()
  }

  if (status === LogChatMsgStatus.deleted) {
    return null
  }

  void tick

  return (
    <div
      className={`LogChatMsg ${expanded ? 'LogChatMsg--expanded' : 'LogChatMsg--collapsed'} ${marked ? 'LogChatMsg--marked' : ''} ${className}`}
      data-glitem-id={glitem.id}
    >
      <LogChatMsgCompactRow
        glitem={glitem}
        expanded={expanded}
        onToggleExpand={() => setExpanded(v => !v)}
        onClickDetail={onClickDetail}
        onStatusChange={async (nextStatus) => {
          setStatus(LogChatMsgStatus.saving)
          glitem.status = nextStatus
          if (glitem.id === -1) {
            setTimeout(() => setStatus(LogChatMsgStatus.idle), 500)
          } else {
            await glitem.save()
            refreshLocal()
            setStatus(LogChatMsgStatus.idle)
          }
        }}
        onNewsworthy={async () => {
          setStatus(LogChatMsgStatus.saving)
          await glitem.setNewsworthy(!glitem.newsworthy)
          refreshLocal()
          setStatus(LogChatMsgStatus.idle)
        }}
        onDelete={async () => {
          const deleted = await glitem.delete()
          if (deleted) {
            setStatus(LogChatMsgStatus.deleted)
            saveCB()
          }
        }}
        canDelete={glitem.showDelete() !== false}
      />
      {expanded && (
        <LogChatMsgExpandPanel
          glitem={glitem}
          onSaving={() => setStatus(LogChatMsgStatus.saving)}
          onIdle={() => setStatus(LogChatMsgStatus.idle)}
          onChanged={refreshLocal}
          onSaveContent={saveContent}
        />
      )}
    </div>
  )
}
